// extracted by mini-css-extract-plugin
module.exports = {"giftCard__submit":"styles_giftCard__submit__ndsKv","giftCard__delivery":"styles_giftCard__delivery__lCi9X"};